import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fa2607d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "CollegePageBackground" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = { id: "headerMainContainer" }
const _hoisted_4 = { id: "schoolLogoContainer" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { id: "schoolIntroduceContainer" }
const _hoisted_7 = { id: "introduceLine1" }
const _hoisted_8 = { id: "schoolName" }
const _hoisted_9 = {
  key: 0,
  id: "schoolAddress"
}
const _hoisted_10 = {
  key: 1,
  id: "ifShuo"
}
const _hoisted_11 = {
  key: 2,
  id: "ifBo"
}
const _hoisted_12 = {
  key: 3,
  id: "ifBao"
}
const _hoisted_13 = {
  key: 0,
  id: "introduceLine2"
}
const _hoisted_14 = { class: "line2Item" }
const _hoisted_15 = { id: "introduceLine3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "menuContainer" }, "院校概况", -1))
const _hoisted_17 = { id: "mainBody" }

import {ref, reactive, computed} from 'vue'
  import {getCollegeInfo} from "@/network/axios";
  import {useRoute, useRouter} from 'vue-router'
  // 必须先声明调用
  
export default /*#__PURE__*/_defineComponent({
  __name: 'CollegePage',
  setup(__props) {

  const route = useRoute();
  const router = useRouter();
  //院校徽章没有，显示暂无数据的判断
  let noDataImg = ref(false);

  let collegeInfo: any = reactive({
    collegeAdmin: '',
    collegeCity: '',
    collegeImg: '',
    collegeLevel: '',
    collegeName: '',
    collegeProperty: '',
    collegeProvince: '',
    collegeType: '',

    // doctor: '',
    // graduateSchool: '',
    // is211: '',
    // is985: '',
    // isdouble: '',
    // masterEligibility: '',
    // master: '',
    // nationalPoint: '',
    collegeLabels: [],
    //第三行 的数组
    line3: []
  });
  let temporaryMasterDoctorBao:any = ref([]);
  let temporaryCollegeLabels:any = ref([]);
  let line3Str;

  getCollegeInfo('/college/getCollegeBasicInfo', {
    params: {
      // collegeCode: 'A1'
      collegeCode: route.params.id
    }
  }).then((res) => {
    // console.log(res.data)
    collegeInfo.collegeAdmin = res.data.data.collegeAdmin;
    collegeInfo.collegeCity = res.data.data.collegeCity;
    collegeInfo.collegeImg = res.data.data.collegeImg;
    if (collegeInfo.collegeImg == '') {
      noDataImg.value = true;
    }
    collegeInfo.collegeLevel = res.data.data.collegeLevel;
    collegeInfo.collegeName = res.data.data.collegeName;
    collegeInfo.collegeProperty = res.data.data.collegeProperty;
    collegeInfo.collegeProvince = res.data.data.collegeProvince;
    collegeInfo.collegeType = res.data.data.collegeType;

    // collegeInfo.doctor = res.data.data.doctor;
    // collegeInfo.graduateSchool = res.data.data.graduateSchool;
    // collegeInfo.is211 = res.data.data.is211;
    // collegeInfo.is985 = res.data.data.is985;
    // collegeInfo.isdouble = res.data.data.isdouble;
    // collegeInfo.masterEligibility = res.data.data.masterEligibility;
    // collegeInfo.master = res.data.data.master;
    // collegeInfo.nationalPoint = res.data.data.nationalPoint;

    collegeInfo.collegeLabels = [];
    collegeInfo.collegeLabels = res.data.data.collegeLabels;
    temporaryMasterDoctorBao.value =  [];
    temporaryMasterDoctorBao.value = collegeInfo.collegeLabels.filter(item => item == '硕士点' || item == '博士点' || item == '推免资格')
    temporaryCollegeLabels.value =  [];
    temporaryCollegeLabels.value = collegeInfo.collegeLabels.filter(item => item != '硕士点' && item != '博士点' && item != '推免资格')
    // console.log(collegeInfo.collegeLabels)
    // console.log(temporaryMasterDoctorBao.value)
    // console.log(temporaryCollegeLabels.value)
    //给第三行数组 添加 内容
    if (res.data.data.collegeLevel != '') {
      collegeInfo.line3.push(res.data.data.collegeLevel);
    }
    if (res.data.data.collegeProperty != '') {
      collegeInfo.line3.push(res.data.data.collegeProperty);
    }
    if (res.data.data.collegeType != '') {
      collegeInfo.line3.push(res.data.data.collegeType);
    }
    if (res.data.data.collegeAdmin != '') {
      collegeInfo.line3.push(res.data.data.collegeAdmin);
    }
    line3Str = collegeInfo.line3.join(' | ');
    // console.log(collegeInfo);
  });

  let isAddress = computed(() => {
    if (collegeInfo.collegeProvince == '' && collegeInfo.collegeCity == '') {
      return false
    } else {
      return true
    }
  });

  let isMaster = computed(() => {
    if (temporaryMasterDoctorBao.value.includes('硕士点')) {
      // return false
      return true
    } else {
      // return true
      return false
    }
  });

  let isDoctor = computed(() => {
    if (temporaryMasterDoctorBao.value.includes('博士点')) {
      // return false
      return true
    } else {
      // return true
      return false
    }
  });

  let isMasterEligibility = computed(() => {
    if (temporaryMasterDoctorBao.value.includes('推免资格')) {
      // return false
      return true
    } else {
      // return true
      return false
    }
  });

  let isdouble = computed(() => {
    if (collegeInfo.isdouble == '') {
      return false
    } else {
      return true
    }
  });

  let is985 = computed(() => {
    if (collegeInfo.is985 == '') {
      return false
    } else {
      return true
    }
  });

  let is211 = computed(() => {
    if (collegeInfo.is211 == '') {
      return false
    } else {
      return true
    }
  });

  let isGraduateSchool = computed(() => {
    if (collegeInfo.graduateSchool == '') {
      return false
    } else {
      return true
    }
  });

  let isNationalPoint = computed(() => {
    if (collegeInfo.nationalPoint == '') {
      return false
    } else {
      return true
    }
  });



return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(collegeInfo).collegeImg!='')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(collegeInfo).collegeImg
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          (_unref(noDataImg))
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                "image-size": 77,
                description: "暂无数据"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(collegeInfo).collegeName), 1),
            (_unref(isAddress))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(collegeInfo).collegeProvince) + _toDisplayString(_unref(collegeInfo).collegeCity), 1))
              : _createCommentVNode("", true),
            (_unref(isMaster))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, "硕"))
              : _createCommentVNode("", true),
            (_unref(isDoctor))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "博"))
              : _createCommentVNode("", true),
            (_unref(isMasterEligibility))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, "保"))
              : _createCommentVNode("", true)
          ]),
          (!(_unref(temporaryCollegeLabels).length ==0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(temporaryCollegeLabels), (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item), 1))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(line3Str)), 1)
        ])
      ]),
      _hoisted_16
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})